import { render, staticRenderFns } from "./FormalQuestions.vue?vue&type=template&id=7b664a24&scoped=true&"
import script from "./FormalQuestions.vue?vue&type=script&lang=js&"
export * from "./FormalQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FormalQuestions.vue?vue&type=style&index=0&id=7b664a24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b664a24",
  null
  
)

export default component.exports